import { GroupMembershipResponse } from '../../../React/Common/Types/Types'
import { AgentResponse, DeviceResponse } from '../../Types/Types'

/**
 * Reduces multiple GroupMembershipResponse objects into a single one by concatenating their ACDAgents and Devices arrays.
 *
 * @param responses - An array of GroupMembershipResponse objects to be reduced.
 * @returns A single GroupMembershipResponse object containing concatenated ACDAgents and Devices.
 */
export const reduceGroupMemberships = (
    responses: Nullable<GroupMembershipResponse>[]
): Nullable<GroupMembershipResponse> =>
    responses?.reduce(
        (
            accum: Nullable<GroupMembershipResponse>,
            next: Nullable<GroupMembershipResponse>
        ): GroupMembershipResponse => ({
            ACDAgents: [...(accum?.ACDAgents ?? []), ...(next?.ACDAgents ?? [])].sort(
                (a: AgentResponse, b: AgentResponse): number => a.AgentNumber.localeCompare(b.AgentNumber)
            ),
            Devices: [...(accum?.Devices ?? []), ...(next?.Devices ?? [])].sort(
                (a: DeviceResponse, b: DeviceResponse): number => a.DeviceNumber.localeCompare(b.DeviceNumber)
            )
        })
    )
